export class ChangeInSceneForceStatusNotification
{
    public Expiration: Date;
    public IsForceAllScenes: boolean;
    public IsOn: boolean;
    public IsOnWithDuration: boolean;
    public LocationId: number;
    public SceneId: number;
    public SceneNumber: number;
    public TypeCode: number;

    constructor(json: object = null)
    {
        if (json)
        {
            Object.assign(this, json);

            this.Expiration = new Date(json['Expiration']);
        }
    }
}
